import Workspace from '@/containers/workspace'
import Tenants from '@/containers/tenants'
import Workers from '@/containers/workers'
import Employees from '@/containers/employees'
import Products from '@/containers/products'
import productsPending from '@/containers/productsPending'
import Configure from '@/containers/configure'
import Members from '@/containers/members'
import Managers from '@/containers/managers'
// import MGroups from '@/containers/mgroups'
// import ProductCategory from '@/containers/productCategory'
import Dashboard from '@/containers/dashboard'
import Banner from '@/containers/banner'
import Finances from '@/containers/finances'
import Orders from '@/containers/orders'
import QrConnectCallbackFrame from '@/containers/qrConnectCallbackFrame'
import Referrals from '@/containers/referrals'
import ReferralSettlement from '@/containers/referrals/settlement'
import RetailReferralSettlement from '@/containers/referrals/retailSettlement'
import TenantFinances from '@/containers/tenantFinances'
import Notifies from '@/containers/notifies'
import NotifiyCenter from '@/containers/notifies/NotifiyCenter'
import Bills from '@/containers/bills'
import CashCoupon from '@/containers/cashCoupon'
import BonusCoupon from '@/containers/bonusCoupon'
// import ReferalRule from '@/containers/referalRule'
import Helps from '@/containers/helps'
import InvitationPromotion from '@/containers/invitationPromotion'
import Account from '@/containers/account'
const appMode = process.env.APP_MODE

export const pages = {
  tenant: [
    // {
    //   path: '/dashboard',
    //   component: Dashboard
    // },
    {
      path: '/workspace',
      component: Workspace
    },
    {
      path: '/employees',
      component: Employees
    },
    {
      path: '/products',
      component: Products
    },
    {
      path: '/configure',
      component: Configure
    },
    {
      path: '/finances',
      component: TenantFinances
    },
    {
      path: '/orders',
      component: Orders
    },
    {
      path: '/notifyCenter',
      component: NotifiyCenter
    },
    {
      path: '/enterprises/:id/bills',
      component: Bills
    },
    {
      path: '/invitation',
      exact: true,
      component: InvitationPromotion
    },
    {
      path: '/account',
      exact: true,
      component: Account
    },
    {
      path: '/helps',
      component: Helps
    }
  ],
  manager: [
    {
      path: '/dashboard',
      component: Dashboard
    },
    {
      path: '/banner',
      component: Banner
    },
    {
      path: '/workspace',
      component: Workspace
    },
    {
      path: '/enterprises',
      exact: true,
      component: Tenants
    },
    {
      path: '/enterprises/:id/employees',
      component: Employees
    },
    {
      path: '/enterprises/:id/products',
      component: Products
    },
    {
      path: '/enterprises/:id/bills',
      component: Bills
    },
    {
      path: '/managers',
      component: Managers
    },
    {
      path: '/productsPending',
      component: productsPending
    },
    // {
    //   path: '/mgroups',
    //   component: MGroups
    // },
    // {
    //   path: '/productCategory',
    //   component: ProductCategory
    // },
    {
      path: '/workers',
      component: Workers
    },
    {
      path: '/members',
      component: Members
    },
    {
      path: '/finances',
      component: Finances
    },
    {
      path: '/orders',
      component: Orders
    },
    {
      path: '/referrals',
      exact: true,
      component: Referrals
    },
    {
      path: '/referrals/:id/settlement',
      component: ReferralSettlement
    },
    {
      path: '/referrals/:id/retailSettlement',
      component: RetailReferralSettlement
    },
    {
      path: '/notifies',
      exact: true,
      component: Notifies
    },
    {
      path: '/cashCoupon',
      exact: true,
      component: CashCoupon
    },
    {
      path: '/bonusCoupon',
      exact: true,
      component: BonusCoupon
    },
    // {
    //   path: '/referalRule',
    //   exact: true,
    //   component: ReferalRule
    // }
  ]
}

export const iframePages = [
  {
    path: '/iframe-products',
    component: Products
  },
  {
    path: '/iframe-configure',
    component: Configure
  },
]

export default pages[appMode]
